import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  DatePicker,
  Upload,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UploadProfilePicture from "../../../components/UploadProfilePicture";

function AddPharmacy() {
  const [form] = Form.useForm();
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);
  const [citiesList, setCitiesList] = useState([]);
  const navigate = useNavigate();
  const [image, setImage] = useState("");

  // on Finish

  const fetchCities = async () => {
    try {
      const response = await axios.get(`${API_URL}userProfiles/get-cities`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const citiesList = response.data.Cities.map((city) => ({
        id: city.id,
        name: city.name,
      }));
      setCitiesList(citiesList);
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };
  useEffect(() => {
    fetchCities();
  }, []);
  const handleSubmit = async (values) => {
    const formattedData = {
      name: values.Pharmacy_Name,
      contactNumber: values.contact,
      logo: image,
      startDate: moment(values.start_date).toISOString(),
      endDate: moment(values.end).toISOString(),
      adminFirstName: values.Pharmacy_Admin_first,
      adminLastName: values.Pharmacy_Admin_second,
      adminContactNumber: values.Admin_contact,
    };
    console.log(formattedData);
    if (formattedData.logo == "") {
      return message.error("Please add an image");
    }
    try {
      const response = await axios.post(
        `${API_URL}/pharmacies`,
        formattedData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      message.success("Pharmacy added successfully!");
      form.resetFields();
      navigate(-1);
    } catch (error) {
      console.error("Error while adding pharmacy:", error);
      message.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    console.log("image", image);
  }, [image]);
  const uploadButton = (
    <div>
      <PlusOutlined />
    </div>
  );
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ width: "100%" }}
      >
        <p className="text-lg font-semibold mb-4">Add New Pharmacy</p>
        <div className="bg-white py-6 sm:py-8 md:py-10 px-4 sm:px-6 md:px-7 rounded-sm">
          <div className="flex flex-col md:flex-row w-full gap-6 md:gap-10">
            <div className="w-full md:w-[14%] flex justify-center">
              <UploadProfilePicture
                value={image ? image : ""}
                onChange={(url) => {
                  setImage(url);
                  form.setFieldsValue({ profilePicture: url });
                }}
              />
            </div>
            <div className="w-full md:w-[85%] space-y-2">
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="w-full sm:flex-1">
                  <Form.Item
                    label={
                      <p
                        style={{
                          color: "#232323",
                          fontWeight: 500,
                          fontSize: "16px",
                        }}
                      >
                        Pharmacy Name
                      </p>
                    }
                    name="Pharmacy_Name"
                    rules={[
                      { required: true, message: "Please Enter a Pharmacy Name" },
                      {
                        whitespace: true,
                        message: "No white Space",
                      },
                    ]}
                  >
                    <Input
                      style={{
                        height: "40px",
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="w-full sm:flex-1">
                  <Form.Item
                    label={
                      <p
                        style={{
                          color: "#232323",
                          fontWeight: 500,
                          fontSize: "16px",
                        }}
                      >
                        Pharmacy Contact Number
                      </p>
                    }
                    name="contact"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter a Pharmacy Contact Number",
                      },
                      {
                        pattern: /^[0-9]{5,11}$/,
                        message: "Contact number must be between 5 and 11 digits",
                      },
                      {
                        whitespace: true,
                        message: "No white Space",
                      },
                    ]}
                  >
                    <Input
                      className="no-arrows"
                      style={{ width: "100%", height: "40px" }}
                      type="text"
                      pattern="\d*"
                      maxLength={11}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="w-full sm:flex-1">
                  <Form.Item
                    label={
                      <p
                        style={{
                          color: "#232323",
                          fontWeight: 500,
                          fontSize: "16px",
                        }}
                      >
                        Contract Start Date
                      </p>
                    }
                    name="start_date"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter a Contract Start Date",
                      },
                    ]}
                  >
                    <DatePicker
                      prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                      suffixIcon={null}
                      placeholder=""
                      style={{ width: "100%", height: "40px" }}
                    />
                  </Form.Item>
                </div>
                <div className="w-full sm:flex-1">
                  <Form.Item
                    label={
                      <p
                        style={{
                          color: "#232323",
                          fontWeight: 500,
                          fontSize: "16px",
                        }}
                      >
                        Contract End Date
                      </p>
                    }
                    name="end"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter a Contract End Date",
                      },
                    ]}
                  >
                    <DatePicker
                      prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                      suffixIcon={null}
                      placeholder=""
                      style={{ width: "100%", height: "40px" }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="border-[2px] p-3 sm:p-4 md:p-5 rounded">
                <div className="mb-4">
                  <p
                    style={{
                      color: "#232323",
                      fontWeight: 500,
                      fontSize: "18px",
                      sm: "20px",
                    }}
                  >
                    Pharmacy Admin
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="w-full sm:flex-1">
                    <Form.Item
                      label={
                        <p
                          style={{
                            color: "#232323",
                            fontWeight: 500,
                            fontSize: "16px",
                          }}
                        >
                          Pharmacy Admin First Name
                        </p>
                      }
                      name="Pharmacy_Admin_first"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Pharmacy Admin First Name",
                        },
                        {
                          whitespace: true,
                          message: "No white Space",
                        },
                      ]}
                    >
                      <Input
                        style={{
                          height: "40px",
                        }}
                      />
                    </Form.Item>
                  </div>
                  <div className="w-full sm:flex-1">
                    <Form.Item
                      label={
                        <p
                          style={{
                            color: "#232323",
                            fontWeight: 500,
                            fontSize: "16px",
                          }}
                        >
                          Pharmacy Admin Second Name{" "}
                        </p>
                      }
                      name="Pharmacy_Admin_second"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Pharmacy Admin Second Name",
                        },
                        {
                          whitespace: true,
                          message: "No white Space",
                        },
                      ]}
                    >
                      <Input
                        style={{
                          height: "40px",
                        }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="w-full sm:flex-1">
                    <Form.Item
                      label={
                        <span style={{ fontSize: "16px", fontWeight: "500" }}>
                          Contract Start Date
                        </span>
                      }
                      name="Pharmacy_start_date"
                      style={{ fontSize: "16px", fontWeight: "500" }}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Contract Start Date",
                        },
                      ]}
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%", height: "40px" }}
                      />
                    </Form.Item>
                  </div>
                  <div className="w-full sm:flex-1">
                    <Form.Item
                      label={
                        <span style={{ fontSize: "16px", fontWeight: "500" }}>
                          Contract End Date
                        </span>
                      }
                      name="Pharmacy_end"
                      style={{ fontSize: "16px", fontWeight: "500" }}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Contract End Date",
                        },
                      ]}
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%", height: "40px" }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="w-full sm:w-1/2">
                    <Form.Item
                      label={
                        <p
                          style={{
                            color: "#232323",
                            fontWeight: 500,
                            fontSize: "16px",
                          }}
                        >
                          Admin Contact Number
                        </p>
                      }
                      name="Admin_contact"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Pharmacy Admin Contact Number",
                        },
                        {
                          pattern: /^[0-9]{11}$/,
                          message: "Contact number must be exactly 11 digits",
                        },
                        {
                          whitespace: true,
                          message: "No white Space",
                        },
                      ]}
                    >
                      <Input
                        className="no-arrows"
                        style={{ width: "100%", height: "40px" }}
                        type="text"
                        pattern="\d*"
                        maxLength={11}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="px-6 py-2 sm:px-8 md:px-10"
                  style={{
                    paddingBlock: "10px",
                    paddingInline: "30px",
                    height: "auto",
                    width: "auto",
                    minWidth: "120px",
                  }}
                >
                  Add
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default AddPharmacy;
